export default "__VITE_ASSET__BURFtiIs__"